import { RouterLink } from '@redux-first-router-link';

import { Grid, Button } from '@simplywallst/ui-core';

import { ROUTE_PORTFOLIO_NEW, ROUTE_PORTFOLIO_DEMO } from '@/constants/routes';

import { PortfolioOnboardingSlideShow } from '@/components/PortfolioOnboardingSlideShow';

export const PortfolioEmptyState = () => {
  return (
    <PortfolioOnboardingSlideShow
      footer={
        <Grid
          templateColumnsMd="max-content max-content"
          justifyContentMd="end"
          gap="8px"
        >
          <Grid rowMd="1" columnMd="2">
            <RouterLink to={{ type: ROUTE_PORTFOLIO_NEW }}>
              <Button styleType="louderLarge" displaySmDown="block">
                Create my portfolio
              </Button>
            </RouterLink>
          </Grid>
          <Grid rowMd="1" columnMd="1">
            <RouterLink to={{ type: ROUTE_PORTFOLIO_DEMO }}>
              <Button styleType="loudLarge" displaySmDown="block">
                Try demo portfolio
              </Button>
            </RouterLink>
          </Grid>
        </Grid>
      }
    />
  );
};
